module.exports = __webpack_public_path__ + "img/cbt.460007d8.svg";